<script setup>
import { HModal, HButton } from '@cnd_fe/ui'

const props = defineProps({
  modelValue: Boolean,
  title: String,
  content: { type: [String, Object, Function], default: '' },
  confirmText: String,
  cancelText: String,
  teleportTo: String,
  confirmVariant: { type: String, default: 'primary' },
  beforeConfirm: { type: Function, default: null },
  preventOutsideClose: { type: Boolean, default: false }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const onConfirm = async () => {
  if (props.beforeConfirm) {
    const ok = await props.beforeConfirm()
    if (!ok) return
  }
  emit('confirm')
  emit('update:modelValue', false)
}
const onCancel = () => {
  emit('cancel')
  emit('update:modelValue', false)
}
</script>
<template>
  <Teleport :to="props.teleportTo ? props.teleportTo : 'body'">
    <HModal :model-value="props.modelValue" @update:model-value="() => {}">
      <template #default="{ titleProps, descriptionProps }">
        <div
          v-if="props.modelValue"
          class="modal-backdrop fade show"
          style="z-index: 1040"
          v-on="props.preventOutsideClose ? { mousedown: (e) => e.stopPropagation() } : {}"
        ></div>
        <div
          id="alertModal"
          class="modal fade show d-block"
          tabindex="-1"
          role="dialog"
          @click.self.prevent
          v-on="props.preventOutsideClose ? { mousedown: (e) => e.stopPropagation() } : {}"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" @click.stop>
              <div class="modal-header offset-sm-0 offset-md-0 offset-lg-0">
                <h5 id="alertModalLabel" class="modal-title" v-bind="titleProps">{{ props.title }}</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-coreui-dismiss="modal"
                  aria-label="Close"
                  @click="onCancel"
                ></button>
              </div>
              <main class="modal-body">
                <div v-bind="descriptionProps" :style="typeof props.content === 'string' && props.content.includes('\n') ? 'white-space: pre-line' : ''">
                  <!-- 문자열이면 그대로 -->
                  <template v-if="typeof props.content === 'string'">
                    {{ props.content }}
                  </template>

                  <!-- VNode/컴포넌트면 렌더 -->
                  <template v-else>
                    <component :is="props.content" />
                  </template>
                </div>
              </main>
              <footer class="modal-footer">
                <HButton v-if="props.cancelText !== ''" class="btn btn-secondary" data-coreui-dismiss="modal" @click="onCancel">{{props.cancelText ?? '취소'}}</HButton>
                <HButton :class="['btn', props.confirmVariant === 'danger' ? 'btn-danger' : 'btn-primary']" @click="onConfirm">{{ props.confirmText ?? '확인' }}</HButton>
              </footer>
            </div>
          </div>
        </div>
      </template>
    </HModal>
  </Teleport>
</template>

<style scoped>
</style>










